import {ChangeDetectionStrategy, Component} from '@angular/core';


@Component({
    selector: 'app-customer-reports',
    template: '<app-reports-view category="Customer"></app-reports-view>',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CustomerReportsComponent {

    category = 'Customer';

    constructor() {
    }

}
